import {Card} from 'platform/components';

import {isArray} from 'ramda-adjunct';

import i18n from '@dms/i18n';
import {testIds, tiresInventoryRoutes} from '@dms/routes';
import {DmsDataGrid, Section, SectionTab, Tires as TiresDG, usePermissions} from '@dms/shared';

import {buildArray, composePath, useRequiredParams} from 'shared/web';

import type {ActionCallback, EagGridMaximization, QueryFilterObject} from 'features/eag-grid';

import {VehicleTireSets} from './components/VehicleTireSets';

interface TiresProps {
  maximization?: EagGridMaximization;
}

export function Tires(props: TiresProps) {
  const [canReadPneuhotel] = usePermissions({permissionKeys: ['pneuhotelRead']});
  const {id: vehicleId} = useRequiredParams();

  const queryModifier = (filter: QueryFilterObject) => ({
    ...filter,
    vehicleId,
  });

  const tireOrdersActionCallback: ActionCallback = ({actionKey, rowId}) => {
    const id = isArray(rowId) ? rowId[0] : rowId;

    if (actionKey === 'redirectDetail') {
      const path = composePath(tiresInventoryRoutes.tireOrderDetail, {params: {id}});
      window.open(path, '_blank')?.focus();
    }
  };

  const tabs = buildArray<SectionTab>([])
    .when(canReadPneuhotel, {
      queryId: 'tireOrders',
      content: (
        <Card
          actions={[
            {
              type: 'button',
              variant: 'link',
              leftIcon: 'action/open_in_new',
              title: i18n.t('page.tiresInventory.labels.tiresInventory'),
              onClick: () => window.open(tiresInventoryRoutes.overview, '_blank'),
            },
          ]}
          title={i18n.t('page.tiresInventory.labels.tireOrders')}
        >
          <DmsDataGrid
            maximization={props.maximization}
            autoHeight
            gridCode="vehicle-tire-order"
            data-testid={testIds.customer.detail('tireOrders')}
            actionCallback={tireOrdersActionCallback}
            queryModifier={queryModifier}
          />
        </Card>
      ),
      title: i18n.t('page.tiresInventory.labels.tireOrders'),
    })
    .when(canReadPneuhotel, {
      queryId: 'tireSets',
      content: <VehicleTireSets vehicleId={vehicleId} maximization={props.maximization} />,
      title: i18n.t('page.tiresInventory.labels.tireSets'),
    })
    .when(canReadPneuhotel, {
      queryId: 'tires',
      content: (
        <TiresDG
          vehicleId={vehicleId}
          gridCode="vehicle-tire-list"
          maximization={props.maximization}
        />
      ),
      title: i18n.t('entity.customer.labels.listOfTires'),
    });

  return <Section tabs={tabs} />;
}
